const currency = (value, locale = "pt-BR", useGrouping = true, maximumFractionDigits = 2, minimumFractionDigits = 2) => {    
    if (value !== undefined && value !== null) {
        value = parseFloat(value).toLocaleString(locale, {maximumFractionDigits, minimumFractionDigits, useGrouping});
    }   
    return value;
}

export default currency;
